import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["appearance", "as", "children", "className", "css", "iconLeft", "iconRight", "size", "style", "variant", "isLoading", "shortcut"];
import React from "react";
import { getAppearance } from "./logic";
import ButtonPrimitive from "./primitives";
import { jsx as _jsx } from "react/jsx-runtime";
var Button = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? "standard" : _ref$appearance,
    as = _ref.as,
    children = _ref.children,
    className = _ref.className,
    css = _ref.css,
    iconLeft = _ref.iconLeft,
    iconRight = _ref.iconRight,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "default" : _ref$size,
    style = _ref.style,
    ignoredVariant = _ref.variant,
    isLoading = _ref.isLoading,
    shortcut = _ref.shortcut,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var _getAppearance = getAppearance(appearance),
    color = _getAppearance.color,
    variant = _getAppearance.variant,
    spinnerColor = _getAppearance.spinnerColor,
    shortcutsVariant = _getAppearance.shortcutsVariant;
  return /*#__PURE__*/_jsx(ButtonPrimitive, _extends({
    color: color,
    variant: variant,
    spinnerColor: spinnerColor,
    iconLeft: iconLeft,
    iconRight: iconRight,
    size: size,
    ref: ref,
    isLoading: isLoading,
    shortcut: shortcut,
    shortcutsVariant: shortcutsVariant
  }, restProps, {
    children: children
  }));
});
Button.displayName = "Button";
export default Button;